import {setLocale} from 'yup'

setLocale({
  mixed: {
    required: 'validation.required',
  },
  string: {
    email: 'validation.email',
    max: 'validation.max',
  },
})
